//#region [IMPORT]

// === THIRD-PARTY ===
import React, { useContext } from 'react';

// === STYLE / MATERIAL UI ===
import { useTheme } from '@mui/material/styles';
import { DragIndicator } from '@mui/icons-material';

// === COMPONENTS ===
import Styled from 'components/Styled/Styled';
import { DragContext } from './GroupDrag';
import {useDrop} from './DropContext';

//#endregion

//-----------------------------------------------------------------
export function DragHandle( props ) {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const { styles=[] } = props;

  const { data_type, drag_data } = useContext( DragContext );
  const { setDrag } = useDrop();

  //#endregion

  //#region [STYLES]

  const CONTAINER = {
    draggable   : true,
    onDragStart : onDragStart ,
    onDragEnd   : onDragEnd   ,
  }

  //#endregion

  //#region [EVENTS]

  /** === Drag & Drop === */

  //-----------------------------------------------------------------
  function onDragStart( event ) {
    //-----------------------------------------------------------------
    setDrag( data_type, drag_data );
    event.stopPropagation();
    event.dataTransfer.effectAllowed = "move";
    event.target.style.opacity = 1.0;
  }

  //-----------------------------------------------------------------
  function onDragEnd( event ) {
    //-----------------------------------------------------------------
    setDrag( null, null );
    event.stopPropagation();
  }

  //#endregion

  //#region [RENDER]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return (
      <Styled styles={[{height:'25px', width: '25px'}, {cursor: 'grab'},...styles]} {...CONTAINER} >
        <DragIndicator />
      </Styled>
    )
  }

  //#endregion

  return display();
}